import { formatDimension, formatQuantityValue, parseFloatValue } from "../../../../helpers/unitOfMeasurementHelpers";

export const searchColumns = [
  { keyName: "tappiId" },
  { keyName: "ifraId" },
  { keyName: "productName" },
  { keyName: "dimension", formatRowData: formatDimension },
  { keyName: "grossWeight", formatRowData: formatQuantityValue },
  { keyName: "rollLength", formatRowData: formatQuantityValue },
  { keyName: "rollSurface", formatRowData: formatQuantityValue },
  { keyName: "productionDate" }
];

export const sortColumns = [
  { keyName: "tappiId" },
  { keyName: "ifraId" },
  { keyName: "productName" },
  { keyName: "dimension", formatRowData: formatDimension },
  { keyName: "grossWeight.value", formatRowData: parseFloatValue },
  { keyName: "rollLength.value", formatRowData: parseFloatValue },
  { keyName: "rollSurface.value", formatRowData: parseFloatValue },
  { keyName: "rollsPerPack", formatRowData: parseFloatValue },
  { keyName: "productionDate" }
];



// WEBPACK FOOTER //
// ./src/components/BillOfLading/List/Rolls/RollsListColumns.js